import { Typography, Link } from "@mui/material";

export default function Copyright() {
    return (
      <Typography variant="body2" color="text.secondary" align="center">
        Copyright © { new Date().getFullYear() } 
        &nbsp;
        <Link href="https://www.conta.com.py" target="_blank">
          Conta
        </Link>{' '}
        <br />
        { 'Invierte en Paraguay 🇵🇾' }
      </Typography>
    );
  }
  